/**
 * @generated SignedSource<<cabc8edda24d2fd54bf699e471c185d4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ToolsSendErrorReportInput = {
  clientMutationId?: string | null | undefined;
  errorReportInfo: ToolsErrorReportInfoInput;
};
export type ToolsErrorReportInfoInput = {
  body: string;
  subject: string;
};
export type ToolsSendErrorReportMutation$variables = {
  input: ToolsSendErrorReportInput;
};
export type ToolsSendErrorReportMutation$data = {
  readonly sendErrorReport: {
    readonly errors: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
      readonly path: string;
    }>;
  };
};
export type ToolsSendErrorReportMutation = {
  response: ToolsSendErrorReportMutation$data;
  variables: ToolsSendErrorReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messages",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToolsSendErrorReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ToolsSendErrorReportPayload",
        "kind": "LinkedField",
        "name": "sendErrorReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ToolsSendErrorReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ToolsSendErrorReportPayload",
        "kind": "LinkedField",
        "name": "sendErrorReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "89942d1cc669a52fc0a0cdd24ae0b7f6",
    "id": null,
    "metadata": {},
    "name": "ToolsSendErrorReportMutation",
    "operationKind": "mutation",
    "text": "mutation ToolsSendErrorReportMutation(\n  $input: ToolsSendErrorReportInput!\n) {\n  sendErrorReport(input: $input) {\n    errors {\n      path\n      messages\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4f08fc453d76d75662372e124e0be27";

export default node;
